module.exports = __webpack_public_path__ + "img/milva-logo-dark.f15446ca.svg";